import Header from "../../components/organismos/Header/Header"
import Footer from "../../components/organismos/Footer/Footer"
import Menu from "../../components/moleculas/Menu/Menu"

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen">
      <Menu />
      <div className="flex flex-col flex-1">
        <Header menurol={true}/>
        <div className="flex-1">
          {children}
        </div>
        <Footer />
      </div>
    </div>
  )
}

